import React from "react";
import { Button } from "react-md";
import { Col, Row } from "react-flexbox-grid";
import successGif from "../../../../../../../assets/images/done-animation.gif";
import errorImg from "../../../../../../../assets/icons/payment/error_red_exclamation.svg";
import EventService from "../../../../../../../service/event/EventService";

/**
 * Terminal screen after a cart approve that generated a Razorpay payment link.
 * `linkBody` merges the channels the operator chose with the link details from
 * the approve response (paymentDetails.paymentLink). If the link itself failed
 * to generate, the approve still succeeded (appointment created) — we surface a
 * retry note instead of the link box. "Done" opens the created appointment.
 */
const CartSuccessWithGeneratedLink = ({
  onDone,
  linkBody,
  profileDetails,
}) => {
  const paymentLink = linkBody?.link ?? "";

  const handleCopy = () => {
    if (!paymentLink) return;
    navigator.clipboard.writeText(paymentLink);
    EventService.emit("showError", { message: "Link copied" });
  };

  return (
    <div className="pld-screen" style={{ textAlign: "center" }}>
      <div>
        <img src={successGif} alt="success" height="150px" />
      </div>

      <div style={{ fontWeight: "bold", fontSize: "22px" }}>
        Cart approved!
      </div>

      <br />

      {paymentLink ? (
        <div>Payment link was successfully shared with the user</div>
      ) : (
        <div>
          The appointment was created, but the payment link could not be
          generated.
        </div>
      )}

      {/* SENT TO BOX */}
      {paymentLink && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="show-shared-options-box zy-dashed-border">
            {linkBody?.sendWhatsapp && (
              <>
                <Row>
                  <Col xs={6}>
                    <div style={{ fontWeight: "500", textAlign: "left" }}>
                      • Sent to Whatsapp
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div
                      style={{
                        fontWeight: "400",
                        color: "gray",
                        textAlign: "left",
                      }}
                    >
                      {`+${linkBody?.whatsappNo?.countryCode ?? ""} ${
                        linkBody?.whatsappNo?.phoneNo ?? ""
                      }`}
                    </div>
                  </Col>
                </Row>
                <br />
              </>
            )}
            {linkBody?.sendEmail && (
              <>
                <Row>
                  <Col xs={6}>
                    <div style={{ fontWeight: "500", textAlign: "left" }}>
                      • Sent to Email
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div
                      style={{
                        fontWeight: "400",
                        color: "gray",
                        textAlign: "left",
                        wordBreak: "break-all",
                        overflowWrap: "break-word",
                        lineHeight: "1.2",
                      }}
                    >
                      {linkBody?.emailAddress}
                    </div>
                  </Col>
                </Row>
                <br />
              </>
            )}
            {linkBody?.sendSms && (
              <>
                <Row>
                  <Col xs={6}>
                    <div style={{ fontWeight: "500", textAlign: "left" }}>
                      • Sms sent
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div
                      style={{
                        fontWeight: "400",
                        color: "gray",
                        textAlign: "left",
                      }}
                    >
                      {`+${linkBody?.smsNumber?.countryCode ?? ""} ${
                        linkBody?.smsNumber?.phoneNo ?? ""
                      }`}
                    </div>
                  </Col>
                </Row>
                <br />
              </>
            )}
            {linkBody?.sendChat && (
              <Row>
                <Col xs={6}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sent to chat
                  </div>
                </Col>
                <Col xs={6}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`${profileDetails?.id ?? ""}`}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
      )}

      <div className="zy-divider"></div>

      {paymentLink ? (
        <>
          {/* NOTE */}
          <div>
            <span style={{ fontWeight: 600 }}>Please note:</span> This link will
            be valid for only {linkBody?.linkValidMins} mins, if payment is not
            made, the cart will remain pending top-up
            {linkBody?.expireAt
              ? ` until ${new Date(linkBody.expireAt)
                  .toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                  .toLowerCase()}`
              : ""}
            .
          </div>

          <br />

          {/* PAYMENT LINK BOX */}
          <div className="payment-link-box">
            <div className="payment-link-label">Payment link:</div>
            <div className="payment-link-url">{linkBody?.link}</div>
            <div
              className={`payment-link-copy ${!paymentLink ? "disabled" : ""}`}
              onClick={handleCopy}
            >
              <i className="material-icons">content_copy</i>
            </div>
          </div>
        </>
      ) : (
        <div className="zy-dashed-border" style={{ marginTop: "8px" }}>
          <div>
            <img src={errorImg} alt="error" height="50px" />
          </div>
          <div className="pld-note-container" style={{ marginTop: "12px" }}>
            <div className="pld-note-box">
              <span className="pld-bold">
                Payment link not generated. Retry from the appointment screen.
              </span>
            </div>
          </div>
        </div>
      )}

      {/* BUTTON */}
      <div className="pld-center">
        <Button raised className="zy-btn-orange pld-main-btn" onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  );
};

export default CartSuccessWithGeneratedLink;
